import { CognitoUserPool } from "amazon-cognito-identity-js";
import { COGNITO_CONFIG } from "../cognitoConfig";

export const userPool = new CognitoUserPool(COGNITO_CONFIG);
